import { Euler, InstancedMesh, Object3D, RawShaderMaterial } from "three";
import { sphericalToCartesianThreeJs } from "../common/Coordinates";
import airportVertexShader from "./shaders/vertex.glsl";
import airportFragmentShader from "./shaders/fragment.glsl";
const MAX_R = 1.04;
const MIN_R = 1.00005;
const MIN_SCALE = 0.000025;
const MAX_SCALE = 0.1;
export default class AirportInstances {
    scale = 1;
    positions;
    mesh;
    constructor(model, sphericalCoordinates) {
        this.positions = sphericalCoordinates;
        const material = new RawShaderMaterial({
            vertexShader: airportVertexShader,
            fragmentShader: airportFragmentShader
        });
        const geometry = model.clone();
        geometry.scale(1, 0.125, 1);
        const airportsCount = sphericalCoordinates.length;
        this.mesh = new InstancedMesh(geometry, material, airportsCount);
        const empty = new Object3D();
        for (let i = 0; i < airportsCount; i++) {
            const position = this.positions[i];
            this.positions[i].r = MAX_R;
            const coords = sphericalToCartesianThreeJs(this.positions[i]);
            empty.setRotationFromEuler(new Euler(position.theta, position.phi + (Math.PI / 2), 0, "YXZ"));
            empty.position.set(coords.x, coords.y, coords.z);
            empty.updateMatrix();
            this.mesh.setMatrixAt(i, empty.matrix);
        }
        this.mesh.instanceMatrix.needsUpdate = true;
    }
    update(λCamera) {
        const desiredScale = MIN_SCALE * (1 - λCamera) + MAX_SCALE * λCamera;
        const newScale = desiredScale / this.scale;
        this.scale *= newScale;
        this.mesh.geometry.scale(newScale, newScale, newScale);
        const airportsCount = this.positions.length;
        const empty = new Object3D();
        for (let i = 0; i < airportsCount; i++) {
            const position = this.positions[i];
            this.positions[i].r = MIN_R * (1 - λCamera) + MAX_R * λCamera;
            const coords = sphericalToCartesianThreeJs(this.positions[i]);
            empty.setRotationFromEuler(new Euler(position.theta, position.phi + (Math.PI / 2), 0, "YXZ"));
            empty.position.set(coords.x, coords.y, coords.z);
            empty.updateMatrix();
            this.mesh.setMatrixAt(i, empty.matrix);
        }
        this.mesh.instanceMatrix.needsUpdate = true;
    }
    dispose() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
    }
    getObject3d() {
        return this.mesh;
    }
}
